import React from 'react'
import vector from '../../assets/pickupAssigned.svg'
import { Link } from 'react-router-dom'
import styles from './PickupAssigned.module.css'

const PickupAssigned = () => {
    return (
        <div className={styles.container}>
            <div className={styles.box}></div>
            <header>
                <Link to="/payment-modes">
                    <i className={styles.backIcon + " fas fa-chevron-left"}></i>
                </Link>
                <h1>Pickup Assigned</h1>
            </header>
            <main>
                <img src={vector} alt="pickup assigned" />
                <div className={styles.textContainer}>
                    <h3>Your Pickup has been arranged</h3>
                    <p>Thank you for choosing us for delivering your valuable stuffs.</p>
                </div>
            </main>
            <Link to="/earnings">
                <button>Track my Courier</button>
            </Link>
        </div>
    )
}

export default PickupAssigned
